import { type SanityFilterGroup } from '@data/sanity/queries/types/cart'
import { type SanityCollectionStrings } from '@data/sanity/queries/types/modules'
import { type UrlParameter } from '@lib/hooks'
import { type Filter, type FilterValue } from '@lib/product'

import Accordion from '@components/accordion'
import Icon from '@components/icon'
import CollectionChip from './chip'

interface CollectionFilterChipsProps {
  collectionStrings: SanityCollectionStrings
  filterGroups: SanityFilterGroup[]
  activeFilters: Filter[]
  activeFilterValueCount: number
  onClick: (newParameters: UrlParameter[]) => void
}

const CollectionFilterChips = ({
  collectionStrings,
  filterGroups,
  activeFilters,
  onClick,
}: CollectionFilterChipsProps) => {
  const activeFilterValues: FilterValue[] = activeFilters.flatMap(
    (activeFilter) =>
      activeFilter.values.map((value) => ({
        name: activeFilter.name,
        value,
      })),
  )

  return (
    <div className="flex">
      <Accordion
        id="collection-filter-chips"
        className="w-full border-t-0"
        innerClassName="max-w-none pb-0"
      >
        <div
          className="flex overflow-x-auto no-scrollbar"
          style={{
            WebkitMaskImage:
              'linear-gradient(90deg,transparent 0, #000 1rem, #000 calc(100% - 1rem), transparent)',
            maskImage:
              'linear-gradient(90deg,transparent 0, #000 1rem, #000 calc(100% - 1rem), transparent)',
          }}
        >
          <ul className="p-4 whitespace-nowrap">
            {activeFilterValues.map((filter, index) => {
              const currentValues =
                activeFilters.find(
                  (activeFilter) => activeFilter.name === filter.name,
                )?.values || []

              const newValues = currentValues
                .filter((value) => value !== filter.value)
                .join()

              const option = filterGroups
                .find((filterGroup) => filterGroup.slug.current === filter.name)
                ?.options?.find(
                  (filterGroupOption) =>
                    filterGroupOption.slug.current === filter.value,
                )

              if (!option) {
                return null
              }

              return (
                <CollectionChip
                  key={index}
                  label={`${collectionStrings.collectionRemoveFilter}: ${option.title}`}
                  title={`${collectionStrings.collectionRemoveFilter}: ${option.title}`}
                  onClick={() =>
                    onClick([
                      {
                        name: filter.name,
                        value: newValues || null,
                      },
                    ])
                  }
                  icon={
                    <Icon
                      id={`remove-chip-${option.slug.current}`}
                      name="Plus"
                      className="rotate-45"
                    />
                  }
                  className="mr-2"
                >
                  {option.title}
                </CollectionChip>
              )
            })}
          </ul>
        </div>
      </Accordion>
    </div>
  )
}

export default CollectionFilterChips
